import { createAction, props } from '@ngrx/store'

export const SOURCE = '[Barter State]'

export const resetState = createAction(
    `${ SOURCE } ResetState`,
)
export const toggleState = createAction(
    `${ SOURCE } ToggleState`, props<{ item: any }>(),
)
export const setStates = createAction(
    `${ SOURCE } SetStates`, props<{ states: number[] }>(),
)